<template>
  <div id="app-header">
    <div class="wrapper">
      <nav class="navbar navbar-inverse navbar-fixed-top">
        <div class="container">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" href="#"><img id="logo" src="../assets/logo.svg" alt=""></a>
          </div>

          <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul class="nav navbar-nav navbar-right">
              <li><a data-toggle="collapse" data-target=".navbar-collapse.in" class="hvr-underline-from-left" href="/">Home</a></li>
              <li><a data-toggle="collapse" data-target=".navbar-collapse.in" class="hvr-underline-from-left" href="#/services">Services</a></li>
              <li><a data-toggle="collapse" data-target=".navbar-collapse.in" class="hvr-underline-from-left" href="#/about">About Us</a></li>
              <li><a data-toggle="collapse" data-target=".navbar-collapse.in" class="hvr-underline-from-left" href="#/build">Build App</a></li>
              <li><a data-toggle="collapse" data-target=".navbar-collapse.in" class="hvr-underline-from-left" href="#/contact">Contact Us</a></li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-header',
  data () {
    return {
    }
  },
  mounted() {
    let vm = this;
  }
}
</script>

<style scoped lang="sass">
  *
    transition: 200ms

  #app-header
    .navbar-brand
      padding: 15px
      @media screen and (max-width: 768px)
        padding: 10px 10px
    #logo
      width: 170px
      height: auto
      @media screen and (max-width: 992px)
        width: 100px
      @media screen and (max-width: 768px)
        width: 80px
    nav
      background: rgba(0,0,0,.8)
      @media screen and (max-width: 768px)
        background: #111
      .container
        .navbar-collapse
          .navbar-right
            li
              margin: 30px 20px
              @media screen and (max-width: 992px)
                margin: 10px 5px
              a
                font-size: .8em
                letter-spacing: 1px
                text-transform: uppercase
                font-weight: 400
                color: white
</style>



// WEBPACK FOOTER //
// AppHeader.vue?7ae27a68